import store from "@/store";

import { assignGroupResourceSlbName, assignGroupResourceEdgeName } from "@/libs/assignFormOptions";

const isAdmin = store.state.userData.privilege == "admin";

import { checkDocumentExist } from "@/api/documentexist";
import { getFormOptions } from "@/api/formoptions";

export const settingZoneExplain = parentVue => {
    return {
        description:
            "<p>Manage resource for each group, includes their asset and limitation. The resource between each group is isolate.</p>"
    };
};

export const groupName = parentVue => {
    return {
        description: "<p>The name of the group, must be unique.</p>",
        withForm: true,
        formTypes: ["createForm"],
        formRender: "FormInput",
        defaultVal: "",
        disabled: () => false,
        validate: [
            {
                required: true,
                message: "群組名稱 不能為空",
                trigger: "blur"
            },
            {
                validator: (rule, value, callback, source, options) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (!/^[a-z0-9\-\_]*$/.test(value))
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateIllegalCharsPrefix")}: a-z 0-9 - _`));
                    if (value.length > 35)
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateExceedLengthPrefix")}: 35`));
                    checkDocumentExist({
                        topic: "groupName",
                        fieldVal: value,
                        groupName: vm.formData.groupName
                    }).then(result => {
                        if (!result.data.success) {
                            return callback(new Error("此群組名無法使用"));
                        }
                        callback();
                    });
                },
                trigger: "blur"
            }
        ]
    };
};
export const slbs = parentVue => {
    const resourceLimits = parentVue.$store.getters.resourceLimits;
    return {
        withForm: isAdmin ? true : false,
        maxItemsCount: resourceLimits.groupMaxAssignSlbCount,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;
            // var slbs = vm.getEsResult
            //     ? params.row.slbs.map((e) => vm.getEsResult.slbs.find((s) => e == s.hostname))
            //     : [];
            var slbs = vm.getEsResult
                ? vm.getEsResult.mapSlbs.find(e => e.groupName == params.row.groupName).groupSlbs
                : [];
            return h("TagList", {
                props: {
                    listData: slbs.map(function (s) {
                        let serviceProvideTypeTag = s.serviceProvideType == "normal" ? "N" : "P";
                        return `${s.hostname}(${serviceProvideTypeTag}):${s.serviceIP} ${s.line}`;
                    }),
                    colors: slbs.map(e => e.runningStat),
                    maxShow: "5",
                    title: `${params.row.groupName}: SLBS`,
                    width: "350"
                }
            });
        },
        remoteOptions: async queryParams => {
            let queryString = new URLSearchParams(queryParams).toString();
            let result = await getFormOptions(`groupresource/slbnames?${queryString}`);
            return result.data.options;
        },
        queryParamsFields: ["groupName"]
    };
};
export const edges = parentVue => {
    const resourceLimits = parentVue.$store.getters.resourceLimits;
    return {
        withForm: isAdmin ? true : false,
        description: "<p>The edges you want to assign to them.</p>",
        maxItemsCount: resourceLimits.groupMaxAssignEdgeCount,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;
            // var edges = vm.getEsResult
            //     ? params.row.edges.map((e) => vm.getEsResult.edges.find((s) => e == s.hostname))
            //     : [];
            var edges = vm.getEsResult
                ? vm.getEsResult.mapEdges.find(e => e.groupName == params.row.groupName).groupEdges
                : [];
            return h("TagList", {
                props: {
                    listData: edges.map(function (edge) {
                        let serviceProvideTypeTag = edge.serviceProvideType == "normal" ? "N" : "P";

                        return `${edge.hostname}(${serviceProvideTypeTag}):${edge.serviceIP}`;
                    }),
                    colors: edges.map(e => e.runningStat),
                    maxShow: "5",
                    title: `${params.row.groupName}: EDGES`,
                    width: "350"
                }
            });
        },
        remoteOptions: async queryParams => {
            let queryString = new URLSearchParams(queryParams).toString();
            let result = await getFormOptions(`groupresource/edgenames?${queryString}`);
            return result.data.options;
        },
        queryParamsFields: ["groupName"]
    };
};

export const action = parentVue => {
    return {
        width: 140,
        render: (h, params) => {
            var vm = parentVue.$refs.rcmTable;
            const editBtn = h("Button", {
                props: {
                    shape: "circle",
                    icon: vm.isEditBtnDisabled ? "md-eye" : "md-create"
                },
                on: {
                    click: () => {
                        vm.editItem(params.row);
                    }
                }
            });

            var dropdownItems = [
                {
                    value: "delete",
                    title: vm.$t("rcmtable.deleteText"),
                    modalTitle: vm.$t("rcmtable.deleteText"),
                    modalContent: vm.$t("rcmtable.confirmDeleteText")
                }
            ];

            const moreBtn = h(
                "Dropdown",
                {
                    props: {
                        trigger: "click",
                        placement: "right",
                        transfer: true,
                        disabled: vm.isDeleteBtnDisabled
                    },
                    on: {
                        "on-click": value => {
                            var currentItem = dropdownItems.find(e => e.value == value);
                            vm.$Modal.confirm({
                                title: currentItem.modalTitle,
                                content: currentItem.modalContent,
                                okText: vm.$i18n.t("rcmtable.confirmText"),
                                cancelText: vm.$i18n.t("rcmtable.cancelText"),
                                onOk: () => {
                                    var deleteItem = Object.assign({}, params.row);
                                    delete deleteItem._index;
                                    delete deleteItem._rowKey;

                                    vm.actionType = "delete";
                                    vm.updateData(vm.esIndex, "delete", deleteItem);
                                }
                            });
                        }
                    }
                },
                [
                    h("a", [
                        h("Button", {
                            props: {
                                shape: "circle",
                                icon: "md-more",
                                key: params.index
                            }
                        })
                    ]),
                    h(
                        "DropdownMenu",
                        {
                            slot: "list"
                        },
                        [
                            dropdownItems.map(function (item) {
                                return h(
                                    "DropdownItem",
                                    {
                                        props: {
                                            name: item.value,
                                            disabled: item.disabled
                                        }
                                    },
                                    item.title
                                );
                            })
                        ]
                    )
                ]
            );

            const actionDivArray = [];

            if (vm.userCanIndex) {
                actionDivArray.push(editBtn);
            }
            actionDivArray.push(moreBtn);

            return h("div", actionDivArray);
        }
    };
};



// WEBPACK FOOTER //
// ./src/view/GroupResource/fields.js